module.exports = __webpack_public_path__ + "static/img/2.fe320067.png";